import {Guideline, GuidelineFunctionTemplate} from "@/modules/guidelines/domain/Guideline";
import {GuidelinesRepo} from "@/modules/guidelines/domain/GuidelinesRepo";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { query_dispatcher_get, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";


function objectToDict(obj: any): Record<string, any> {
    const dict: Record<string, any> = {};

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                // Recursively convert nested object
                dict[key] = objectToDict(value);
            } else {
                dict[key] = value;
            }
        }
    }

    return dict;
}
export class GuidelinesApiRepo implements GuidelinesRepo {

    command_dispatcher: CommandDispatcher
    query_dispatcher: QueryDispatcher
    constructor() {
        this.command_dispatcher = sync_command_dispatcher
        this.query_dispatcher = query_dispatcher_get
    }

    guideline_api_to_domain(g_data) {
        return new Guideline(g_data.id, g_data.user_id,g_data.username, g_data.company_id, g_data.company_name, g_data.params, g_data.condition, g_data.consequence, g_data.description)
    }
    guideline_domain_to_api(guid) {
        let data = JSON.parse(JSON.stringify(objectToDict(guid)));
        return data
    }
    func_template_api_to_domain(ft_data) {
        return new GuidelineFunctionTemplate(ft_data.name, ft_data.description, ft_data.params_schema, ft_data.func_name)
    }

    async find_by_id(g_id: number): Promise<Guideline | null> {
        let res = await this.query_dispatcher.dispatch('guideline.by.id', {g_id: g_id})
        return this.guideline_api_to_domain(res)
    }
    async get_guidelines_list(limit, offset): Promise<any> {
        let args = {force_get: true} //raro pero asseguro no trencar altres coses
        let ordering = '-id'
        if (ordering) {
            args['ordering'] = ordering
        }
        if (limit) {
            args['limit'] = limit
        }
        if (offset) {
            args['offset'] = offset
        }
        let res = await this.query_dispatcher.dispatch('all.guidelines',args )
        let domain_res = []
        for (let g in res.results) {
            domain_res.push(this.guideline_api_to_domain(res.results[g]))
        }
        return {results:domain_res, count: res.count}

    }
    async save(guid){
        let data = this.guideline_domain_to_api(guid)
        let args = {guideline:data}
        let res = await this.command_dispatcher.dispatch('save.guideline', args)
        return res.output.guideline_id 
    }
    async get_options(): Promise<any> {
        let res = await this.query_dispatcher.dispatch('guideline.options', {})
        let cndtions = res.conditions.map((c) => this.func_template_api_to_domain(c))
        let cnsq = res.consequences.map((c) => this.func_template_api_to_domain(c))
        return {conditions: cndtions, consequences: cnsq}
    }

    async delete(guid){
        let args = {guideline_id: guid.id}
        let res = await this.command_dispatcher.dispatch('delete.guideline', args)
        return res
    }

    async get_guideline_stats(g_id){
        let args = {guideline_id: g_id}
        let res = await this.query_dispatcher.dispatch('guideline.execution.info', args)
        return res
    }
}